const flattenColorPallette = require('tailwindcss/lib/util/flattenColorPalette')
    .default;

window.colorPalette = flattenColorPallette(
    require('@northeastern-web/kernl-ui/defaultTheme').colors
);

window.basicColorPalette = Object.fromEntries(
    [
        'black',
        'white',
        'red-600',
        'gray-cool-500',
        'gray-warm-500',
        'gray-warm-700',
        'indigo-500',
        'dark-blue-600',
        'blue-500',
        'aqua-500',
        'teal-500',
        'green-500',
        'yellow-400',
        'orange-500',
        'gold',
        'silver',
    ].map(c => [c, colorPalette[c]])
);

delete colorPalette.current;
delete colorPalette.transparent;
